export const SoniaBiografy = () => {
  return (
    <section
      id="indications"
      className="py-10 px-4 lg:px-0 flex justify-center"
    >
      <div className="w-full lg:max-w-screen-md xl:max-w-screen-xl 2xl:max-w-screen-2xl">
        <div className="mt-6 flex flex-col md:flex-row items-center md:items-start text-center md:text-left gap-6">
          <div className="flex-shrink-0">
            <img
              src={require("../../assets/sonia.jpg")}
              alt="Sônia Maria de Meneses Silva"
              className="rounded-xl w-40 h-40 object-cover mx-auto md:mx-0"
            />
          </div>
          <div className="text-gray-700 text-lg leading-relaxed">
            <p>
              <strong>Sônia Maria de Meneses Silva</strong> realizou
              pós-doutorado na Universidade de São Paulo-USP. Doutorado em
              História pela Universidade Federal Fluminense (UFF), mestrado em
              História Social pela Universidade Federal do Rio de Janeiro
              (UFRJ). É professora associada da Universidade Regional do Cariri
              URCA, sendo atualmente coordenadora do Programa ProfHistória da
              mesma instituição. Editora-Chefe da Revista Brasileira de História
              (2023-2025); Coordenadora do projeto Negacionismo contemplado no
              Edital Mulheres na Ciência da Fundação Cearense de Apoio ao
              Desenvolvimento Científico e Tecnológico -FUNCAP. Bolsista de
              produtividade do CNPQ. Tem como áreas de atuação: História do
              Tempo Presente, História Pública, Teoria da História, Ensino de
              História, Imprensa, Ditaduras e Negacionismo. Organizou publicou o
              Livro História, Memória e Direitos (2018) pela Editora Letra e
              Voz, "Operação Midiográfica: o Golpe de 1964 e a Folha de São
              Paulo, pela editora Intermeios, produto da tese de doutorado
              desenvolvida na Universidade Federal Fluminense. Organizou,
              juntamente com Juniele Rabelo de Almeida, o livro História
            </p>
            <p className="mt-4">
              Pública em Debate - Patrimônio, Educação e Mediações do Passado
              pela editora Letra e Voz.
            </p>
            <div className="mt-4">
              <p>
                Redes sociais: <strong>@soniammeneses</strong>
              </p>
              <p>
                ID Lattes:{" "}
                <a
                  href="http://lattes.cnpq.br/5558125167892774"
                  className="text-blue-600 hover:underline"
                >
                  Acessar
                </a>
              </p>
              <p>
                ID ORCID:{" "}
                <a
                  href="https://orcid.org/0000-0001-5099-0530"
                  className="text-blue-600 hover:underline"
                >
                  Acessar
                </a>
              </p>
              <p>
                Email:{" "}
                <a
                  href="mailto:sonia.meneses@urca.br"
                  className="text-blue-600 hover:underline break-all"
                >
                  sonia.meneses@urca.br
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
